<template>
  <div class="custom-room-upload-container">
    <div class="header">
      Custom Room Upload
    </div>
    <div v-if="secret == ''">
      <check-secret :user="user" :project-name="projectName" @unlock="unlock"/>
    </div>
    <template v-else>
      <div class="room-types">
        <div v-for="r in roomTypes" class="room-type" :key="r" @click="expanded = r">
          {{ r }}
          <div v-if="expanded == r" class="take-picture">
            <label for="file" class="camera-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-camera"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>
            </label>
            <input
              type="file"
              name="file"
              id="file"
              class="inputfile"
              accept="image/*;capture=camera"
              @change="upload(r)"
              :disabled="uploadInProgress"
              ref="photo"
            />
            <div v-if="uploadInProgress" class="progress-bar">
              <progress-bar :progress="progress"/>
            </div>
            <div v-if="uploadCount[roomTypes.indexOf(r)] > 0" class="upload-count">
              Uploaded {{ uploadCount[roomTypes.indexOf(r)] }} pictures <i class="fa fa-check"/>
            </div>
          </div>
        </div>

        <div class="add" @click="add = true">
          + Other
        </div>
      </div>
      
      <div class="help">
        <div class="help-header" @click="showHelp = !showHelp">
          <div class="expand-icon" :class="{'expanded': showHelp }"><i class="fa fa-chevron-right"/></div>
          Help
        </div>
        <ul v-if="showHelp">
          <li>
          <div class="help-item">
            <div class="problem">
              My camera screen is black when trying to take a picture.
            </div>
            <div class="solution">
              This is most probably a permission issue. Go to your phones settings and make sure your browser has permission to access the camera.
            </div>
          </div>
          </li>
        </ul>
      </div>
    </template>

    <div v-if="add" class="modal-overlay" @click="add = false">
      <div class="add-room modal-content" @click.stop>
        <div class="close-icon" @click="add = false">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" style="transform:rotate(45deg);position:relative;top:4px;"><g fill="none"><g style="stroke-width:3;stroke:#F7103C"><path d="M8 8L8-1 8 8 -1 8 8 8ZM8 8L17 8 8 8 8 17 8 8Z"/></g></g></svg>
        </div>
        <div class="add-header">Add Room</div>
        <div class="name">
          <input type="text" class="input" v-model="newRoomName" placeholder="Which Room?"/>
        </div>
        <div class="save-button" :class="{ 'inactive': newRoomName == '' }" @click="addRoom(newRoomName)">Add</div>
      </div>
    </div>

  </div>
</template>

<script>
// import axios from 'axios'
import projectService from '@/services/project-service.js'
import { deURLify } from '@/utils/urlify.js'

import CheckSecret from '@/components/utility/CheckSecret.vue'
import ProgressBar from '@/components/utility/ProgressBar.vue'

export default {
  name: 'CustomRoomUpload',
  props: {
    user: {
      type: String,
      required: true,
    },
    project: {
      type: String,
      required: true,
    },
  },
  components: {
    CheckSecret,
    ProgressBar,
  },
  data() {
    return {
      secret: '',

      roomTypes: ['Livingroom', 'Bedroom', 'Kitchen'],
      uploadCount: [],
      expanded: '',
      
      add: false,
      newRoomName: '',

      progress: 0,
      uploadInProgress: false,
      
      showHelp: false,
    }
  },
  mounted() {
    this.roomTypes.forEach(() => this.uploadCount.push(0))
  },
  methods: {
    unlock(secret) {
      this.secret = secret
    },
    async upload(roomName) {
      this.err = null
      let files = this.$refs.photo[0].files

      if(!this.user || !this.project) {
        this.err = 'invalid configuration, cannot upload.'
        return
      }

      let formData = new FormData();
      formData.append('user', this.user)
      formData.append('projectName', this.projectName)
      formData.append('secret', this.secret)

      for(let i = 0; i < files.length; i++ ){
        let file = files[i];
        let filenameParts = file.name.split('.')
        const fileExtension = filenameParts[filenameParts.length-1]
        const filename = roomName + '-' + this.randomId(4) + '.' + fileExtension
        let renamedFile = new File([file], filename, { type: file.type })
        // console.dir(renamedFile)
        formData.append('files', renamedFile);
      }
      
      const config = {
        onUploadProgress: (progressEvent) => {
          this.progress = Math.round((progressEvent.loaded*100) / progressEvent.total)
        },
        headers: {
          'Content-Type': 'multipart/form-data'
        },
      }

      this.uploadInProgress = true
      this.progress = 0

      await projectService.roomUpload(formData, config)
        .then(() => this.uploadCount[this.roomTypes.indexOf(roomName)]++)
      this.uploadInProgress = false
    },
    addRoom(roomName) {
      if(!this.roomTypes.includes(roomName)) {
        this.roomTypes.push(roomName)
        this.uploadCount.push(0)
        this.expanded = roomName
      }
      this.add = false
    },
    randomId(length) {
      let result = ''
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      const charactersLength = characters.length
      for(let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
      return result
    }
  },
  computed: {
    projectName() {
      return deURLify(this.project)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.header {
  padding: 50px;
  padding-bottom: 30px;
  font-size: 26px;
  font-weight: bold;
}

.room-types {
  padding: 0px 20px; 

  .room-type {
    padding: 10px 20px;
    color: $primary;
    border: 1px solid $light;
    margin-bottom: 10px;
    border-radius: $border-radius;
    // @include shadow;
    font-size: 20px;

    .take-picture {
      padding-top: 20px;
    }
  }

  .add {
    font-size: 20px;
    color: $light;
    text-align: right;
    margin-top: 20px;
  }
}

.add-room {
  padding: 50px;
  text-align: left;
  max-width: 90vw;
  box-sizing: border-box;
  border-radius: $border-radius;
  position: relative;
  background-color: white;

  .add-header {
    margin-bottom: 20px;
    font-size: 20px;
  }
  .save-button {
    margin-top: 50px;
    padding: 20px 30px;
    background-color: $primary;
    border-radius: $border-radius;
    color: white;
    text-align: center;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      box-shadow: 2px 2px 10px rgba(black, 0.4);
    }
  }
  .inactive {
    background-color: rgb(232, 232, 232);
    cursor: not-allowed;
  }

  .close-icon {
    position: absolute;
    top: -16px;
    right: -16px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    background-color: white;
    box-shadow: 2px 2px 10px rgba(black, 0.4);
    text-align: center;
    cursor: pointer;
  }
}

.upload-count {
  font-size: 16px;
  color: $light;
}

.progress-bar {
  max-width: 300px;
  margin: auto;
  margin-top: 50px;
}

.camera-button {
  cursor: pointer;
  color: $primary;
}

.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}

.help {
  margin-top: 50px;
  padding: 30px;
  text-align: left;

  .help-header {
    font-weight: 700;
    font-size: 20px;
    color: $secondaryText;
  }

  .help-item {
    margin: 5px 0px;

    .problem {
      font-weight: 500;
    }
  }
}

.expand-icon {
  display: inline-block;
  transition: 0.5s all;
  color: $secondaryText;
  margin-right: 8px;

  &.expanded {
    transform: rotate(90deg);
  }
}
</style>